module.exports = __webpack_public_path__ + "img/document-scanner.51306cdf.svg";